// @todo linting doesn't work with this path (yet?)
import {
  collapse,
  expandCollapse,
  handleClickOutside,
} from '~/js/utils/expand-collapse';
import { default as mobileCheck } from '~/js/utils/is-mobile';
import scrollLock from '~/js/utils/scroll-lock';

const menuToggle = document.querySelector('.header__menu-toggle');
const menu = document.querySelector('.header__menu');
const parentLinks = document.querySelectorAll('.menu-link-main--has-children');

// Functions & handlers.
const toggleMobileMenu = () => {
  const isOpen = menu.classList.contains('header__menu--open');
  const icon = menuToggle.querySelector('i');

  if (isOpen) {
    menu.classList.remove('header__menu--open');
    menu.setAttribute('aria-hidden', true);
    menuToggle.setAttribute('aria-expanded', false);
    icon.classList.remove('fa-times');
    icon.classList.add('fa-bars');
    scrollLock.unlock();
  } else {
    menu.classList.add('header__menu--open');
    menu.setAttribute('aria-hidden', false);
    menuToggle.setAttribute('aria-expanded', true);
    icon.classList.remove('fa-bars');
    icon.classList.add('fa-times');
    scrollLock.lock();
  }
};

const collapseAll = () => {
  parentLinks.forEach((link) => {
    const subMenu = link.nextElementSibling;
    collapse(subMenu, link);
  });
};

(() => {
  // Add event listener for opening/closing mobile menu.
  if (menuToggle) {
    menuToggle.addEventListener('click', toggleMobileMenu);
  }

  // Add event listeners for parent links.
  parentLinks.forEach((link) => {
    const subMenu = link.nextElementSibling;

    link.addEventListener('click', (e) => {
      e.preventDefault();
      const isMobile = mobileCheck();

      // If click happened on desktop, close any open submenus first.
      if (!isMobile) {
        collapseAll();
      }
      expandCollapse(subMenu, link);
    });

    // Add click outside handler on desktop.
    if (!mobileCheck()) {
      handleClickOutside(subMenu, link);
    }
  });

  // Close all dropdowns on Esc.
  window.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      collapseAll();
    }
  });
})();
